import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
  SheetFooter,
} from '@/components/ui/sheet';
import { Plus, Ticket } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DiscountCodeForm, DiscountCodeFormRef } from 'pages/Discounts/DiscountCodeForm';
import { useRef } from 'react';

export const CreateDiscountCodeSheet = ({
  isOpen,
  setIsCreateModalOpen,
}: {
  isOpen: boolean;
  setIsCreateModalOpen: (open: boolean) => void;
}) => {
  const formRef = useRef<DiscountCodeFormRef>(null);

  const handleSave = () => {
    formRef.current?.submit();
  };

  return (
    <Sheet open={isOpen} onOpenChange={setIsCreateModalOpen}>
      <SheetTrigger asChild>
        <Button className="w-full sm:w-auto">
          <Plus className="w-4 h-4 mr-2" />
          Create Discount Code
        </Button>
      </SheetTrigger>
      <SheetContent
        side="right"
        className="p-0 sm:max-w-[600px] lg:max-w-[700px] xl:max-w-[800px] h-full"
      >
        <div className="grid h-full grid-rows-[auto_1fr_auto]">
          {/* Header */}
          <SheetHeader className="border-b bg-white px-6 py-4">
            <div className="flex items-center space-x-3">
              <div className="rounded-lg bg-orange-100 p-2">
                <Ticket className="h-6 w-6 text-orange-600" />
              </div>
              <SheetTitle className="text-xl font-semibold text-gray-900">
                Create New Discount Code
              </SheetTitle>
            </div>
          </SheetHeader>

          {/* Content Area - Scrollable */}
          <div className="overflow-y-auto p-6">
            <DiscountCodeForm ref={formRef} onCancel={() => setIsCreateModalOpen(false)} />
          </div>

          {/* Footer */}
          <SheetFooter className="border-t bg-gray-50 px-6 py-4">
            <div className="flex w-full items-center justify-end space-x-2">
              <Button variant="outline" onClick={() => setIsCreateModalOpen(false)}>
                Cancel
              </Button>
              <Button
                onClick={handleSave}
                disabled={formRef.current?.isDisabled}
                className="bg-orange-600 hover:bg-orange-700"
              >
                Create Discount Code
              </Button>
            </div>
          </SheetFooter>
        </div>
      </SheetContent>
    </Sheet>
  );
};
